
































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import PaymentPlanInvoicesModal from '@/web/components/payment-plans/PaymentPlanInvoicesModal.vue';
import { errorToMessage } from '@/core/utils/errors';
import CancelCustomerOrderModal from '@/web/components/customers/CancelCustomerOrderModal.vue';
import PauseCustomerOrderModal from '@/web/components/customers/PauseCustomerOrderModal.vue';
import ResumeCustomerOrderModal from '@/web/components/customers/ResumeCustomerOrderModal.vue';
import { saveAs } from '@/web/utils/save-file';
import EnrollCustomerModal from '@/web/components/customers/EnrollCustomerModal.vue';
import CustomerDetailActionBar from '@/web/components/customers/CustomerDetailActionBar.vue';
import { HMPaginatedTable } from '@/web/components/common';
import Status from '@/web/components/customers/Status.vue';

export default Vue.extend({
  name: 'CustomerDetailProducts',
  components: {
    Status,
    CustomerDetailActionBar,
    HMPaginatedTable,
  },
  data() {
    return {
      tableFields: [
        {
          name: 'purchase_date',
          title: this.$t('ORDERS.TABLE.PURCHASE_DATE'),
          ordering: 'created',
        },
        {
          name: 'product_name',
          title: this.$t('ORDERS.TABLE.PRODUCT'),
          cssClass: 'h5',
        },
        {
          name: 'status',
          title: this.$t('PRODUCTS.TABLE.STATUS'),
        },
        {
          name: 'amount',
          title: this.$t('ORDERS.TABLE.AMOUNT'),
        },
        {
          name: 'is_payment_plan',
          title: '',
        },
        {
          name: 'download',
          cssClass: 'p-0 fa-fw',
        },
        {
          name: 'cancel',
          cssClass: 'p-0 fa-fw',
        },
        {
          name: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      customer: state => state.sale.customerDetail as CustomerResponse,
    }),
    ...mapGetters('sale', ['customerPurchases']),
  },
  methods: {
    selectPaymentPlan(paymentPlan) {
      this.$modal.show(PaymentPlanInvoicesModal, {
        paymentPlan,
        refreshFn: () => {
          this.loadCustomerDetails();
        },
      });
    },
    async loadCustomerDetails() {
      try {
        await this.$store.dispatch(
          'sale/getCustomerDetail',
          this.$route.params.id
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load customer details',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async downloadInvoice(order) {
      try {
        const data = await this.$store.dispatch('sale/downloadInvoice', order);
        const blob = new Blob([data], {
          type: 'application/pdf;charset=utf-8;',
        });
        const name = order.product?.product_name || 'invoice';
        saveAs(blob, `${name}.pdf`);
      } catch (error) {
        console.error(error);
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to download invoice',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async sendInvoice(order) {
      try {
        await this.$store.dispatch('sale/sendCustomerInvoice', order);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.INVOICE_SENT'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.INVOICE_SENT_TEXT'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load customer details',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async pauseOrder(order: SalesPurchaseResponse): Promise<void> {
      this.$modal.show(PauseCustomerOrderModal, { orderId: order.id }, null, {
        'before-close': () => {
          this.loadCustomerDetails();
          this.$refs.customerPurchasesTable.refresh();
        },
      });
    },
    async resumeOrder(order: SalesPurchaseResponse): Promise<void> {
      this.$modal.show(ResumeCustomerOrderModal, { orderId: order.id }, null, {
        'before-close': () => {
          this.loadCustomerDetails();
          this.$refs.customerPurchasesTable.refresh();
        },
      });
    },
    cancelOrder(order) {
      this.$modal.show(
        CancelCustomerOrderModal,
        { orderId: order.id },
        undefined,
        {
          'before-close': () => {
            this.loadCustomerDetails();
            this.$refs.customerPurchasesTable.refresh();
          },
        }
      );
    },
    enrollCustomer() {
      this.$modal.show(
        EnrollCustomerModal,
        {
          customerId: this.customer.id,
        },
        {},
        {
          'before-close': () => {
            this.loadCustomerDetails();
            this.$refs.customerPurchasesTable.refresh();
          },
        }
      );
    },
    getPurchaseAccessBlockedText(purchase) {
      if (purchase.status) return '';
      if (purchase.is_gift) {
        return this.$t('PRODUCTS.TEXT.GIFT_PURCHASE');
      }
      if (this.isRecurring) {
        if (purchase.is_access_blocked) {
          if (purchase.is_past_available_days)
            return this.$t(
              'PRODUCTS.TEXT.PURCHASE_EXPIRED_PAST_AVAILABILITY_DAYS'
            );
          if (purchase.is_outside_schedule)
            return this.$t('PRODUCTS.TEXT.PRODUCT_SCHEDULE_PREVENTING_ACCESS');
        } else {
          return this.$t('PRODUCTS.TEXT.MEMBERSHIP_HAS_EXPIRED');
        }
      } else {
        if (purchase.is_past_available_days)
          return this.$t(
            'PRODUCTS.TEXT.PURCHASE_EXPIRED_PAST_AVAILABILITY_DAYS'
          );
        if (purchase.is_outside_schedule)
          return this.$t('PRODUCTS.TEXT.PRODUCT_SCHEDULE_PREVENTING_ACCESS');
      }
      return '';
    },
  },
});
